import React from 'react';
import { Popover } from 'antd';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import './policy-notes-popover.scss';

const PolicyNotesPopover: React.FC = () => {
    return (
        <div className="policy-notes-wrapper">
            <div className="policy-notes-title">Some notes before you apply policy</div>
            <Popover overlayClassName="policy-notes-popover" placement={'top'}
                     trigger={['hover', 'click']}
                     content={
                         <div className="policy-notes-popover-content">
                             These are the current best practice policies that AT&T
                             recommends for customers to allow secure access
                             between their networks and Internet.
                             These policies should be reviewed by customer to
                             ensure that they meet their specific needs. You can always
                             customize this policy to meet your specific needs.
                         </div>
                     }>
                <CustomIcon type={IconType.INFO} className={'info-icon'}/>
            </Popover>
        </div>
    );
};

export default PolicyNotesPopover;
